import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { SoilQualityType } from '@services/cleanfill-api/cleanfill-api.generated';
import { SoilQualityTypeService } from '@mappers/soil-quality-type/soil-quality-type.service';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'soilQualityType'
})
export class SoilQualityTypePipe implements PipeTransform {
  constructor(private soilQualityTypeService: SoilQualityTypeService) {}

  transform(value: SoilQualityType): string {
    return this.soilQualityTypeService.getLabel(value);
  }
}
